// NL v4-v7: puntos de color en tarjetas + Quick add (hoja inferior) en colecciones y recomendados.
if (!window.__nlQuickAdd) {
window.__nlQuickAdd = true;

const SIZE_ROWS = [
  ['S', 45.6, 69.8],
  ['M', 50.7, 74.9],
  ['L', 55.7, 77.4],
  ['XL', 59.5, 80],
  ['2XL', 63.3, 85],
];
const DOTS = { negro: '#111111', black: '#111111', 'jet black': '#111111', blanco: '#ffffff', white: '#ffffff', gris: '#8b8b8b', 'vintage white': '#f3efe3', hueso: '#f3efe3', crema: '#f3efe3', 'café': '#795548', cafe: '#795548' };

function esc(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}

// Las URLs de recomendados ya traen parámetros (?pr_prod_strat=...): agregar la variante sin romperlos
function withVariant(url, id) {
  try {
    const u = new URL(url, window.location.origin);
    if (id) u.searchParams.set('variant', id);
    return u.pathname + u.search;
  } catch (err) {
    return url;
  }
}

function cardImage(card) {
  return card.querySelector('.card-gallery img, .product-card__content img');
}

window.addEventListener(
  'click',
  (e) => {
    const dot = e.target.closest && e.target.closest('.nl-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const card = dot.closest('product-card');
    if (!card) return;
    card.querySelectorAll('.nl-dot').forEach((d) => {
      d.classList.toggle('is-active', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
    const x = dot.closest('.nl-card-x');
    if (x) x.dataset.currentColor = dot.dataset.color;
    const img = cardImage(card);
    if (img && dot.dataset.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = dot.dataset.img;
    }
    const link = card.querySelector('.product-card__link');
    if (link && x && dot.dataset.variant) {
      link.href = withVariant(x.dataset.url, dot.dataset.variant);
    }
  },
  true
);

let sheet;
let state = null;

function ensureSheet() {
  if (sheet) return sheet;
  sheet = document.createElement('dialog');
  sheet.className = 'nl-qa-sheet';
  sheet.setAttribute('aria-label', 'Agregar al carrito');
  document.body.appendChild(sheet);
  sheet.addEventListener('click', (e) => {
    if (e.target === sheet) sheet.close();
  });
  sheet.addEventListener('click', onSheetClick);
  return sheet;
}

function findVariant(color, size) {
  const { data } = state;
  return data.variants.find((v) => {
    const okC = data.colorPos ? v.o[data.colorPos - 1] === color : true;
    const okS = data.sizePos ? v.o[data.sizePos - 1] === size : true;
    return okC && okS;
  });
}

function imgFor(color) {
  const { data } = state;
  if (data.colorPos) {
    const v = data.variants.find((x) => x.o[data.colorPos - 1] === color && x.img);
    if (v) return v.img;
  }
  return data.img;
}

function render() {
  const { data, color, size, title, url, error, sgOpen } = state;
  const colorOpt = data.colorPos ? data.options[data.colorPos - 1] : null;
  const sizeOpt = data.sizePos ? data.options[data.sizePos - 1] : null;
  const variant = findVariant(color, size);
  const needSize = sizeOpt && !size;

  let html = '<div class="nl-qa' + (error ? ' has-error' : '') + '">';
  html += '<div class="nl-qa__grab" aria-hidden="true"></div>';
  html += '<div class="nl-qa__head"><img class="nl-qa__img" alt="" src="' + esc(imgFor(color) || '') + '">';
  html += '<div><p class="nl-qa__title">' + esc(title) + '</p><p class="nl-qa__price">' + esc(data.price) + '</p></div>';
  html += '<button type="button" class="nl-qa__close" data-act="close" aria-label="Cerrar"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';

  if (colorOpt) {
    html += '<div class="nl-qa__label"><span>Color: <b>' + esc(color) + '</b></span></div><div class="nl-qa__opts nl-qa__opts--color">';
    colorOpt.values.forEach((c) => {
      const dot = DOTS[c.toLowerCase()] || '#8b8b8b';
      html += '<button type="button" class="nl-qa__opt' + (c === color ? ' is-selected' : '') + '" data-act="color" data-val="' + esc(c) + '"><span class="nl-color-dot" style="--nl-dot:' + dot + '"></span>' + esc(c) + (c === color ? ' ✓' : '') + '</button>';
    });
    html += '</div>';
  }

  if (sizeOpt) {
    html += '<div class="nl-qa__label"><span>Talla: ' + (size ? '<b>' + esc(size) + '</b>' : '<span class="nl-qa__ph">elige una</span>') + '</span>';
    html += '<button type="button" class="nl-qa__sg" data-act="sg" aria-expanded="' + (sgOpen ? 'true' : 'false') + '">' + (sgOpen ? 'Ocultar medidas' : 'Ver medidas') + '</button></div>';
    if (sgOpen) {
      const rows = data.sg || SIZE_ROWS;
      const hasSleeve = rows[0] && rows[0].length > 3;
      html += '<table class="nl-qa__table"><thead><tr><th>Talla</th><th>Pecho</th><th>Largo</th>' + (hasSleeve ? '<th>Manga</th>' : '') + '</tr></thead><tbody>';
      rows.forEach((r) => {
        html += '<tr' + (r[0] === size ? ' class="is-current"' : '') + '><th>' + r[0] + '</th><td>' + r[1] + ' cm</td><td>' + r[2] + ' cm</td>' + (hasSleeve ? '<td>' + r[3] + ' cm</td>' : '') + '</tr>';
      });
      html += '</tbody></table>';
    }
    html += '<div class="nl-qa__opts nl-qa__opts--size">';
    sizeOpt.values.forEach((s) => {
      const v = findVariant(color, s);
      const avail = v && v.a;
      html += '<button type="button" class="nl-qa__opt' + (s === size ? ' is-selected' : '') + '" data-act="size" data-val="' + esc(s) + '"' + (avail ? '' : ' disabled') + '>' + esc(s) + '</button>';
    });
    html += '</div><p class="nl-qa__err" role="alert">Elige tu talla para agregar al carrito.</p>';
  }

  let cta = 'Agregar al carrito';
  if (needSize) cta = 'Elige tu talla';
  else if (!variant || !variant.a) cta = 'Agotado';
  html += '<button type="button" class="nl-qa__cta" data-act="add"' + (state.busy ? ' aria-busy="true"' : '') + '>' + (state.busy ? 'Agregando…' : state.added ? 'Agregado ✓' : cta) + '</button>';
  html += '<a class="nl-qa__more" href="' + esc(withVariant(url, variant ? variant.id : null)) + '">Ver detalles del producto</a>';
  html += '</div>';
  sheet.innerHTML = html;
}

async function addToCart() {
  const { data, color, size } = state;
  if (data.sizePos && !size) {
    state.error = true;
    render();
    return;
  }
  const v = findVariant(color, size);
  if (!v || !v.a || state.busy) return;
  state.busy = true;
  render();
  try {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('add failed');
    state.busy = false;
    state.added = true;
    render();
    document.dispatchEvent(new CustomEvent('nl:cart-added', { detail: { variantId: v.id } }));
    setTimeout(() => {
      sheet.close();
      openCart();
    }, 650);
  } catch (err) {
    state.busy = false;
    render();
    window.location.href = withVariant(state.url, v.id);
  }
}

function openCart() {
  if (window.AVADA_CDP && typeof window.AVADA_CDP.openCart === 'function') {
    window.AVADA_CDP.openCart();
    return;
  }
  const trigger = document.querySelector('.header-actions__cart-icon, cart-drawer-component button, a[href$="/cart"]');
  if (trigger) trigger.click();
}

function onSheetClick(e) {
  const b = e.target.closest('[data-act]');
  if (!b) return;
  const act = b.dataset.act;
  if (act === 'close') {
    sheet.close();
    return;
  }
  if (act === 'color') {
    state.color = b.dataset.val;
    state.added = false;
    render();
    return;
  }
  if (act === 'size') {
    state.size = b.dataset.val;
    state.error = false;
    state.added = false;
    render();
    return;
  }
  if (act === 'sg') {
    state.sgOpen = !state.sgOpen;
    render();
    return;
  }
  if (act === 'add') {
    addToCart();
  }
}

function openQuickAdd(card) {
  const x = card.querySelector('.nl-card-x');
  const json = x && x.querySelector('.nl-qa-data');
  if (!json) return false;
  let data;
  try {
    data = JSON.parse(json.textContent);
  } catch (err) {
    return false;
  }
  const colorOpt = data.colorPos ? data.options[data.colorPos - 1] : null;
  const color = colorOpt ? x.dataset.currentColor || x.dataset.featuredColor || colorOpt.values[0] : null;
  state = { data, color, size: null, title: x.dataset.title, url: x.dataset.url, error: false, busy: false, added: false, sgOpen: false };
  ensureSheet();
  render();
  sheet.showModal();
  return true;
}

// Reemplaza el quick add nativo por nuestra hoja (en window/captura: corre antes que el tema)
function interceptQuickAdd(e) {
  const btn = e.target.closest && e.target.closest('product-card .quick-add__button, product-card .quick-add button');
  if (!btn) return;
  const card = btn.closest('product-card');
  if (!card || !card.querySelector('.nl-card-x')) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (e.type === 'click') openQuickAdd(card);
}
window.addEventListener('click', interceptQuickAdd, true);
window.addEventListener('pointerdown', interceptQuickAdd, true);

function prepareCards(root) {
  (root || document).querySelectorAll('product-card').forEach((card) => {
    const x = card.querySelector('.nl-card-x');
    if (!x || card.dataset.nlReady) return;
    card.dataset.nlReady = '1';
    card.querySelectorAll('.quick-add__button--choose, .quick-add__button').forEach((b) => {
      b.removeAttribute('on:click');
      b.setAttribute('aria-label', 'Agregar rápido');
    });
    const active = x.querySelector('.nl-dot.is-active');
    const link = card.querySelector('.product-card__link');
    if (active && link && active.dataset.variant) {
      link.href = withVariant(x.dataset.url, active.dataset.variant);
    }
  });
}
prepareCards();
// Tarjetas que llegan después (scroll infinito, recomendados): revisar todo el documento
let nlPrepT;
new MutationObserver(() => {
  clearTimeout(nlPrepT);
  nlPrepT = setTimeout(() => prepareCards(document), 30);
}).observe(document.body, { childList: true, subtree: true });
}
